// ─────────────────────────────────────────────────────────────────────────
//  INFORMATIONS LÉGALES DE TATIE SOSO — À COMPLÉTER
//  Tant qu'une valeur vaut null, les pages légales affichent un encadré
//  orange « À compléter » à sa place. Remplis-les avant la mise en ligne.
// ─────────────────────────────────────────────────────────────────────────
export const LEGAL = {
  // Nom de l'entreprise ou de la personne qui exploite le site
  // ex. "Tatie Soso SRL" ou "Sophie Dupont (personne physique)"
  operatorName: null,
  // Forme juridique : "SRL", "ASBL", "personne physique (indépendante)"…
  legalForm: null,
  // Adresse du siège (rue, n°, code postal, ville, pays)
  address: null,
  // Numéro d'entreprise BCE, ex. "BE 0123.456.789"
  companyNumber: null,
  // Numéro de TVA (souvent identique au numéro BCE) ou "non assujetti à la TVA"
  vatNumber: null,
  // Adresse e-mail de contact (questions, réclamations, données personnelles)
  // ⚠️ TEMPORAIRE : adresse inventée en attendant la vraie — elle ne reçoit
  // probablement aucun message. À remplacer avant d'accueillir du public.
  contactEmail: "contact@tatiesoso.be",
  // Téléphone (facultatif) — laisse null pour ne pas l'afficher
  phone: null,
  // Responsable de la publication (nom de la personne)
  publisher: null,
};

// Réseaux sociaux affichés dans le pied de page (null = icône masquée)
// ex. facebook: "https://www.facebook.com/tatiesoso"
export const SOCIAL = {
  facebook: null,
  instagram: null,
  linkedin: null,
};

// Version des textes : à changer quand les CGV ou la politique changent.
// Elle est enregistrée avec l'acceptation de chaque utilisateur.
export const TERMS_VERSION = "2026-10-11";
export const TERMS_DATE = "11 octobre 2026";
